<template>
    <view class="test">
        <iframe class="pdfPlayer" :src="pdfUrl"></iframe>
        <view class="download">
            下载此
            <a :href="pdfUrl" :download="pdfUrl">PDF 文件</a>
        </view>
    </view>
</template>

<script>
export default {
    props:{
        pdfUrl:String
    }
}
</script>




<style lang="scss" scoped>
.test{
    height: 100%;
    width: 100%;
    .pdfPlayer{
        width: 100%;
        height:800px;
        border: 0;
    }
    .download{
        display: flex;
        margin-top: 10px;
        margin-bottom: 60px;
        a{
            margin-left: 10px;
            text-decoration:none
        }
    }
}
</style>